import React from 'react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserAuth } from '../context/AuthContext';
import { Typography, Button } from '@material-tailwind/react';

const Signin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { signIn, checkIfAdmin } = UserAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const isAdmin = await checkIfAdmin(email);
      if (!isAdmin) {
        setError('This User is not an admin');
        return;
      }

      await signIn(email, password);
      navigate('/account');
    } catch (e) {
      setError(e.message);
    }
  };

  return (
    <div className="max-w-[700px] mx-auto my-16 p-4">
      <div>
        <h1 className="text-2xl font-bold py-2">Sign in to your account.</h1>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="flex flex-col py-2">
          <label className="py-2 font-medium">Email Address</label>
          <input
            onChange={(e) => setEmail(e.target.value)}
            className="border p-3"
            type="email"
          />
        </div>
        <div className="flex flex-col py-2">
          <label className="py-2 font-medium">Password</label>
          <input
            onChange={(e) => setPassword(e.target.value)}
            className="border p-3"
            type="password"
          />
        </div>
        <Button
          onClick={handleSubmit}
          variant="filled"
          size="md"
          className="mt-2 bg-[#ffc700]"
        >
          Sign In!
        </Button>
      </form>
      <Typography variant="h5" color="red" className="text-center">
        {error}
      </Typography>
    </div>
  );
};

export default Signin;
